// Gateway Mode Enum
export const GATEWAY_MODE = {
  TEST: 0,
  VERIFICATION: 1,
  LIVE: 2
};

// Gateway Mode Display Labels
export const GATEWAY_MODE_LABELS = {
  [GATEWAY_MODE.TEST]: 'Test Mode',
  [GATEWAY_MODE.VERIFICATION]: 'Verification Mode',
  [GATEWAY_MODE.LIVE]: 'Live Mode'
};

// Provider IDs
export const PROVIDER_IDS = {
  SMEPAY: 'smepay',
  RAZORPAY: 'razorpay',
  TALLY: 'tally'
};

// Provider Display Names
export const PROVIDER_NAMES = {
  [PROVIDER_IDS.SMEPAY]: 'SMEPay',
  [PROVIDER_IDS.RAZORPAY]: 'RazorPay',
  [PROVIDER_IDS.TALLY]: 'Tally'
};

export const PROVIDER_SIGNUP_INFO = {
  [PROVIDER_IDS.SMEPAY]: {
    helperText: 'New to SMEPay?',
    ctaText: 'Create SMEPay account',
    signupUrl: 'https://partner.smepay.in/merchant/onboarding/ygvyfQthZZhmFSTtncB4p8duqCrQAJzTVmpn2XNkjJj3R6U9MNtmd95nK7RJE1Xl?signature=89c75488c84bc5fd1a8b5ebeeea49791983f40620832162f9480db4294b6d103'
  },
  [PROVIDER_IDS.RAZORPAY]: {
    helperText: 'New to Razorpay?',
    ctaText: 'Create Razorpay account',
    signupUrl: 'https://rzp.io/rzp/lCUN7iPp'
  }
};

// Provider-specific field schemas
export const PROVIDER_SCHEMAS = {
  [PROVIDER_IDS.SMEPAY]: [
    {
      name: 'keyId',
      label: 'Client ID',
      type: 'text',
      required: true,
      helpText: 'Your SMEPay Client ID from the merchant dashboard'
    },
    {
      name: 'secretKey',
      label: 'Client Secret',
      type: 'password',
      required: true,
      helpText: 'Your SMEPay Client Secret (keep this secure)'
    },
    {
      name: 'url',
      label: 'API URL',
      type: 'text',
      required: false,
      helpText: 'API endpoint URL (auto-filled based on mode)'
    },
    {
      name: 'bankId',
      label: 'Settlement Bank Account',
      type: 'bank',
      required: true,
      helpText: 'Bank account for receiving payment gateway settlements'
    }
  ],
  [PROVIDER_IDS.RAZORPAY]: [
    {
      name: 'keyId',
      label: 'Key ID',
      type: 'text',
      required: true,
      helpText: 'Your RazorPay Key ID from the dashboard'
    },
    {
      name: 'secretKey',
      label: 'Key Secret',
      type: 'password',
      required: true,
      helpText: 'Your RazorPay Key Secret (keep this secure)'
    },
    {
      name: 'url',
      label: 'Webhook URL',
      type: 'text',
      required: false,
      helpText: 'Webhook URL for payment notifications (optional)'
    },
    {
      name: 'bankId',
      label: 'Settlement Bank Account',
      type: 'bank',
      required: true,
      helpText: 'Bank account for receiving payment gateway settlements'
    }
  ]
};

// Get schema for a specific provider
export const getProviderSchema = (providerId) => {
  return PROVIDER_SCHEMAS[providerId] || [];
};

// Get provider name
export const getProviderName = (providerId) => {
  return PROVIDER_NAMES[providerId] || providerId;
};

export const getProviderSignupInfo = (providerId) => {
  return PROVIDER_SIGNUP_INFO[providerId] || null;
};

// Get mode label
export const getModeLabel = (mode) => {
  return GATEWAY_MODE_LABELS[mode] || 'Unknown Mode';
};
